export default [
  {
    label: '解决方案',
    children: [
      {
        label: '电子合同',
        path: '/home/solution/contract'
      },
      {
        label: '版权保护',
        path: '/home/solution/copyright'
      },
      {
        label: '艺术品溯源',
        path: '/home/solution/art'
      },
      {
        label: '药品/保健品溯源',
        path: '/home/solution/medicine'
      },
      {
        label: '证书保全',
        path: '/home/solution/cert'
      }
    ]
  },
  // {
  //   label: '查询校验',
  //   children: [
  //     {
  //       label: '哈希校验',
  //       path: '/normal/query/#hash'
  //     },
  //     {
  //       label: '原文查询',
  //       path: '/normal/query/#content'
  //     }
  //   ]
  // },
  {
    label: '印刻链',
    path: '/home/ink'
  },
  {
    label: '数据大屏',
    path: '/blank/discard'
  },
  {
    label: '开发者文档',
    path: '/blank/discard'
  },
  {
    label: '控制台',
    path: '/blank/discard'
  }
  // {
  //   label: '登录',
  //   path: '/blank/discard'
  // },
  // {
  //   label: '注册',
  //   path: '/blank/discard'
  // }
]


// WEBPACK FOOTER //
// ./src/conf/collapse.ts